<label class="form-label">{{ field.name | translateField: { obj: field, property: 'name' } }}</label>
<ng-select *ngIf="field.fieldType.name === 'Dropdown' && field.sourceType?.name === 'json'" [(ngModel)]="value" [items]="list" #spec="ngModel" 
    [class.error]="!value && form.submitted && field.required && !readOnlyStatus" placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}" 
    [readonly]="readOnlyStatus" bindLabel="{{langEnglish ? 'nameEnglish' : 'name'}}" (change)="onChange($event)">
</ng-select>

<ng-select *ngIf="field.fieldType.name === 'Dropdown' && field.sourceType?.name === 'api'" [(ngModel)]="value" [items]="list" 
    [class.error]="!value && form.submitted && field.required && !readOnlyStatus" placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}" 
    [readonly]="readOnlyStatus" bindLabel="{{langEnglish ? 'nameEnglish' : 'name'}}" (change)="onChange($event)">
</ng-select>

<ng-select *ngIf="field.fieldType.name === 'Dropdown' && field.sourceType?.name === 'api server'" [searchable]="true" 
    [class.error]="!value && form.submitted && field.required && !readOnlyStatus"
    (keyup)="onKey($event)" [(ngModel)]="value" [items]="list" placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{ field.name | translateField: { obj: field, property: 'name' } }}" 
    [readonly]="readOnlyStatus" bindLabel="{{langEnglish ? 'nameEnglish' : 'name'}}" (change)="onChange($event)">
</ng-select>
<span *ngIf="!value && form.submitted && field.required && !readOnlyStatus" class="invalid-form">
    <small class="form-text text-danger"
        *ngIf="!value && !readOnlyStatus">
        {{ field.name | translateField: { obj: field, property: 'name' } }} {{'COMMON.VALIDATIONS.REQUIRED' | translate}}
    </small>
</span>
